var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 17 17",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_970_693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.875 7.875H2.63882L4.83145 5.693C5.07611 5.4495 5.07704 5.05378 4.83354 4.80912C4.59004 4.56444 4.19429 4.56353 3.94964 4.807L0.683887 8.057C0.683668 8.05719 0.683512 8.0574 0.683324 8.05759C0.439293 8.30109 0.438512 8.69809 0.683262 8.9424C0.683481 8.94259 0.683637 8.94281 0.683824 8.943L3.94957 12.193C4.1942 12.4364 4.58995 12.4356 4.83348 12.1909C5.07698 11.9462 5.07604 11.5505 4.83139 11.307L2.63882 9.125H15.875C16.2202 9.125 16.5 8.84519 16.5 8.5C16.5 8.15481 16.2202 7.875 15.875 7.875Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentcolor",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbutton);
export default __webpack_public_path__ + "static/media/backbutton.0e21c5d9394ae0d83cddba0065853846.svg";
export { ForwardRef as ReactComponent };